import React, { useEffect, useRef, useState } from 'react';
import { IoClose } from "react-icons/io5";
import { BrowserView, isMobile, isTablet } from 'react-device-detect';
import { fmesh, foundFeature } from '../../../core/globalVariables.js';
import Drawer from 'react-modern-drawer';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import Chart from "chart.js/auto";
import { MdOutlineAddToPhotos } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import { MdOutlineLayers } from "react-icons/md";

const PDFTotals = ({
  isVisible,
  polygonCustomLayerRef,
  clickedInfoHeader,
  globalState,
  globalRefs,
  longstandingGeoJSONRef,
  originalGeoJSONforComparingRef
}) => {
  const [activeTab, setActiveTab] = useState("TOTAL");
  const [modalOtherOriginal, setmodalOtherOriginal] = useState(null);
  const [modalOtherAmended, setmodalOtherAmended] = useState(null);
  const [modalSkylarkId, setModalSkylarkId] = useState(null);
  const [selectedMetricValue, setSelectedMetricValue] = useState(null);
  const [selectedKeyValue, setSelectedKeyValue] = useState(null);
  const [landKeySelectedKeyColourOriginal, setlandKeySelectedKeyColourOriginal] = useState(null);
  const [landKeySelectedKeyColourAmended, setlandKeySelectedKeyColourAmended] = useState(null);
  const [totalSumMetric, setTotalSumMetric] = useState(0);
  const [totalSumMetricOriginal, setTotalSumMetricOriginal] = useState(0);
  const [totalSumsValue, setTotalSumsValue] = useState(null);
  const [totalSumsValueOriginal, setTotalSumsValueOriginal] = useState(null);
  const [isRighdivrawerVisible, setIsRighdivrawerVisible] = useState(false);
  const [multilayerDetails, setMultilayerDetails] = useState('');

  const [multilayerOriginalGroupDetails, setMultilayerOriginalGroupDetails] = useState('');
  const [multiGroupDetails, setMultilayerGroupDetails] = useState('');

  const [multilayerOriginalParcelDetails, setMultilayerOriginalParcelDetails] = useState('');
  const [multiParcelDetails, setMultilayerParcelDetails] = useState('');

  const [valuesFromGroupData, setValuesFromGroupData] = useState('');

  const [moreThanOneLayer, setMoreThenOneLayer] = useState(false);

  const [moreThanOnePolygonSelected, setMoreThenOnePolygonSelected] = useState(false);

  let selectedYearEditing = globalState.selectedYearEditing;
  let setIsVisible = globalState.setIsVisible;
  let selectedMetric = globalState.selectedMetric;
  let landKeySelectedKey = globalState.landKeySelectedKey;
  let hasChangedKeyValue = globalState.hasChangedKeyValue;
  let multiLayerSelected = globalState.multiLayerSelected;
  let setMultiLayerSelected = globalState.setMultiLayerSelected;
  let multuLayerSelectedArray = globalState.multuLayerSelectedArray;
  let setMultuLayerSelectedArray = globalState.setMultuLayerSelectedArray;
  let layers = globalState.layers;
  let greoupingSelected = globalState.greoupingSelected;
  let setGreoupingSelected = globalState.setGreoupingSelected;
  let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
  let setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;

  const PDFctxtotalSumSummaryUseRef = useRef();

  let mobileStatus = isMobile ? "mobile" : "not-mobile";

  let PDFTotalsRef = globalRefs.PDFTotalsRef;

  if (isTablet) mobileStatus = "not-mobile";

  function roundToTwoDecimals(value) {
    return typeof value === 'number' ? Math.round(value * 100) / 100 : value;
  }

  function formatAllMetricsForYear(featureDataTimeseries, selectedYear) {
    let availableMetrics = Object.keys(featureDataTimeseries).filter(m => m !== 'coordinates');
    let yearDataExists = availableMetrics.some(metric => featureDataTimeseries[metric]?.[selectedYear] !== undefined);
    {
      availableMetrics.map((metric) => {
        return null;
      })
    }
    return (
      <div className="clickedInfoTable">
        <div>
          {availableMetrics.map((metric) => {
            let value = featureDataTimeseries?.[metric]?.[selectedYear];
            if (value !== undefined) {
              if (metric === "BoundaryChange") {
                value = value === "000,000" ? "False" : "True";
              } else if (typeof value === "object") {
                value = JSON.stringify(value); // Convert objects to a string
              } else if (!isNaN(value) && value !== null && value !== "") {
                value = roundToTwoDecimals(value); // Format numbers
              }
            } else {
              value = "";
            }
            const truncatedValue = value.length > 10 ? `${value.substring(0, 10)}…` : value;
            return (
              <div key={metric} className="clickedInfoRow">
                <div className="clickedInfoLeftHandColumnInline">{metric.substring(0, 20)}: {truncatedValue}</div>
              </div>
            );
          })}
          {!yearDataExists && (
            <div className="noDataMessage">
              <div colSpan="2">No data available for the selected year</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (clickedInfoHeader !== null) {
      for (let feature of originalGeoJSONforComparingRef.current.features) {
        if (feature.skylark_id === clickedInfoHeader) {
          const timeseriesData = feature.feature_data_simple_timeseries;
          setSelectedMetricValue(roundToTwoDecimals(timeseriesData[selectedMetric]?.[selectedYearEditing]) || "No data available");
          setmodalOtherOriginal(formatAllMetricsForYear(timeseriesData, selectedYearEditing));
          setModalSkylarkId(feature.skylark_id.substring(0, 15) + '...');
          setSelectedKeyValue(timeseriesData[landKeySelectedKey]?.[selectedYearEditing]);
        }
      }
    }
    if (clickedInfoHeader !== null) {
      for (let feature of longstandingGeoJSONRef.current.features) {
        if (feature.skylark_id === clickedInfoHeader) {
          const timeseriesData = feature.feature_data_simple_timeseries;
          setSelectedMetricValue(roundToTwoDecimals(timeseriesData[selectedMetric]?.[selectedYearEditing]) || "No data available");
          setmodalOtherAmended(formatAllMetricsForYear(timeseriesData, selectedYearEditing));
          setModalSkylarkId(feature.skylark_id.substring(0, 15) + '...');
          setSelectedKeyValue(timeseriesData[landKeySelectedKey]?.[selectedYearEditing]);
        }
      }
    }
  }, [clickedInfoHeader, selectedYearEditing, selectedMetric, longstandingGeoJSONRef, hasChangedKeyValue, landKeySelectedKey, longstandingGeoJSONRef.current]);

  // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
  // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
  // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
  // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 

  let totalSum = 0;

  useEffect(() => {
    if (longstandingGeoJSONRef.current) {
      for (let i = 0; i < longstandingGeoJSONRef.current.features.length; i++) {
        let metricValue;
        const feature = longstandingGeoJSONRef.current.features[i];
        const deletedYear = feature.feature_data_standard?.deleted;
        if (!deletedYear || deletedYear > selectedYearEditing) {
          if (feature.feature_data_simple_timeseries[selectedMetric] !== undefined) {
            metricValue = feature.feature_data_simple_timeseries[selectedMetric][selectedYearEditing];
            if (metricValue !== undefined) {
              totalSum += metricValue;
            }
          }
        }
      }
    }
    if (typeof totalSum === "number" && !isNaN(totalSum) && totalSum !== 0) {
      setTotalSumMetric(totalSum);
    } else {
      setTotalSumMetric(0);
    }
  }, [selectedMetric, longstandingGeoJSONRef.current, selectedYearEditing]);

  // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
  // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
  // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
  // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 

  let totalSumOriginal = 0;

  useEffect(() => {
    function check() {
      if (originalGeoJSONforComparingRef.current) {
        for (let i = 0; i < originalGeoJSONforComparingRef.current.features.length; i++) {
          let metricValue;
          if (originalGeoJSONforComparingRef.current.features[i].feature_data_simple_timeseries[selectedMetric] !== undefined) {
            metricValue = originalGeoJSONforComparingRef.current.features[i].feature_data_simple_timeseries[selectedMetric][selectedYearEditing];
            if (metricValue !== undefined) {
              totalSumOriginal += metricValue;
            }
          }
        }
      }
      if (typeof totalSumOriginal === "number" && !isNaN(totalSumOriginal) && totalSumOriginal !== 0) {
        setTotalSumMetricOriginal(totalSumOriginal);
      } else {
        setTotalSumMetricOriginal(0);
      }
    }
    check();
  }, [selectedMetric, originalGeoJSONforComparingRef.current, selectedYearEditing, longstandingGeoJSONRef.current]);

  // TOTAL SUM BAR CHARTS - - - - - - -
  // TOTAL SUM BAR CHARTS - - - - - - -
  // TOTAL SUM BAR CHARTS - - - - - - -
  // TOTAL SUM BAR CHARTS - - - - - - -

  useEffect(() => {
    const PDFctxtotalSumSummarycanvas = document.getElementById("PDFtotalSumSummary");
    if (!PDFctxtotalSumSummarycanvas) return;

    const PDFctxtotalSumSummary = PDFctxtotalSumSummarycanvas.getContext("2d");

    if (PDFctxtotalSumSummaryUseRef.current) {
      PDFctxtotalSumSummaryUseRef.current.destroy();
    }
    const labels = ["Original Total Sum", "Amended Total Sum"];
    const dataValues = [totalSumMetricOriginal, totalSumMetric];
    const backgroundColors = ["#808080", "#2E8B57"];
    PDFctxtotalSumSummaryUseRef.current = new Chart(PDFctxtotalSumSummary, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Value Comparison",
            data: dataValues,
            backgroundColor: backgroundColors,
            borderRadius: 6,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
        animation: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: { precision: 0 },
          },
        },
      },
    });
  }, [activeTab, multiGroupDetails, multilayerOriginalGroupDetails, longstandingGeoJSONRef, originalGeoJSONforComparingRef, selectedMetric, landKeySelectedKey, selectedYearEditing, totalSumMetric, totalSumMetricOriginal,
  ]);

  const tabIcons = {
    TOTAL: <MdOutlineAddToPhotos />,
  };

  return (

    <>

      <div style={{
        fontSize: 12,
        position: 'absolute',
        zIndex: 15,
        width: 400,
        paddingBottom: 15,
        overflow: 'hidden',
        backgroundColor: 'white',
      }}
      ref={PDFTotalsRef}
      >
        <BrowserView>
          <div className='clicked_info_tabs'>
            {["TOTAL"].map(tab => (
              <div
                key={tab}
                className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                style={{
                  backgroundColor: activeTab === tab ? 'white' : 'white',
                  color: activeTab === tab ? 'black' : 'white',
                  fontSize: '1.5em',
                  display: 'none',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
              </div>
            ))}
          </div>
          <>
            <div className='clicked_info_inner'>
              <div className='clicked_info_section'>
                <div className='clickedInfoLeftHandColumn'>Original Total {selectedMetric} </div>
                <div className='clickedInfoRightHandColumn'>
                  {totalSumMetricOriginal.toFixed(2)}
                </div>
              </div>
              <div style={{ position: 'absolute', top: '0px', right: '0', width: '50%', textAlign: 'left', backgroundColor: '#fff', color: 'white', opacity: '1', padding: '10px', fontSize: '16px', lineHeight: '1.5' }}>
                <div className='clicked_info_section'>
                  <div className='clickedInfoLeftHandColumn'>New Total {selectedMetric} </div>
                  <div className='clickedInfoRightHandColumn'>
                    {totalSumMetric.toFixed(2)}
                  </div>
                </div>
              </div>
              <div style={{ padding: '15px' }}>
                <div style={{ width: '100%', height: '250px', top: '0px', position: 'relative' }}>
                  <canvas id="PDFtotalSumSummary" height="300" />
                </div>
              </div>
            </div>
          </>

        </BrowserView>
      </div >
    </>

  );
};

export default PDFTotals;
